import { z } from 'zod';
import { polygonSchema } from '@ais-ui/utils';
import { PolygonGeometry } from '@ais-ui/api-spec/portserver';

export const TERMINAL_TYPES = [
  'Undefined',
  'Container',
  'Break bulk',
  'Dry bulk',
  'Liquid bulk',
  'Neo bulk',
  'Refrigerated',
  'RoRo',
  'Project',
  'Passenger',
  'Multi purpose',
  'Leisure',
  'Shipyard',
] as const;

export type TerminalType = (typeof TERMINAL_TYPES)[number];

// Schema for inner area form
export const innerAreaFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  terminalType: z.string().optional(),
  polygon: polygonSchema.nullable(),
});

export type InnerAreaFormValues = z.infer<typeof innerAreaFormSchema>;

// Helper to convert API polygon to form-compatible polygon type
export function convertPolygonToForm(
  polygon: PolygonGeometry | undefined,
): z.infer<typeof polygonSchema> | null {
  if (!polygon?.coordinates) return null;
  const coords = polygon.coordinates.filter(
    (ring): ring is ([number, number] | [number, number, number])[] =>
      Array.isArray(ring) &&
      ring.every(
        (pt) =>
          Array.isArray(pt) && pt.length >= 2 && pt[0] != null && pt[1] != null,
      ),
  );
  if (coords.length === 0) return null;
  return { type: 'Polygon' as const, coordinates: coords };
}
